import DOMPurify from "dompurify";
import {
  RICH_TEXT_ALLOWED_TAGS,
  RICH_TEXT_ALLOWED_ATTR,
} from "../constants/richTextSanitization";

/**
 * Sanitizes HTML content to prevent XSS attacks
 *
 * Uses DOMPurify with a restrictive allowlist of tags and attributes.
 * Safe for displaying user-generated content to public users.
 *
 * @param html - Raw HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering via dangerouslySetInnerHTML
 *
 * @example
 * <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(userContent) }} />
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
    ALLOWED_ATTR: RICH_TEXT_ALLOWED_ATTR,
  });
};
